export default __webpack_public_path__ + "static/media/chat.f832f557.svg";